import type { Page } from './types'

/**
 * Follow `next_cursor` until the list ends (or `maxItems`). For small lists
 * that pickers need in full, such as applications. Don't use for messages.
 */
export async function fetchAll<T>(
  fetchPage: (cursor: string | undefined) => Promise<Page<T>>,
  maxItems = 2000,
): Promise<T[]> {
  const items: T[] = []
  let cursor: string | undefined
  do {
    const page = await fetchPage(cursor)
    items.push(...page.items)
    cursor = page.next_cursor ?? undefined
  } while (cursor && items.length < maxItems)
  return items
}
